import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetTransferRequestDetailsId = createAsyncThunk(
  "GetTransferRequestDetailsId/GetTransferRequestDetailsId",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/TransferRequestDetails/GetSpecificTransferRequestDetails",
        param
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const DeleteTransferRequestDetails = createAsyncThunk(
  "DeleteTransferRequestDetails/DeleteTransferRequestDetails",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/TransferRequestDetails/DeleteTransferRequestDetails",
        param
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const UpdateTransferRequestDetails = createAsyncThunk(
  "UpdateTransferRequestDetails/UpdateTransferRequestDetails",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/TransferRequestDetails/EditTransferRequestDetails",
        param
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const AddTransferRequestDetails = createAsyncThunk(
  "AddTransferRequestDetails/AddTransferRequestDetails",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/TransferRequestDetails/AddTransferRequestDetails",
        param
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const TransferRequestValidation = createAsyncThunk(
  "AddTransferRequestDetails/TransferRequestValidation",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/TransferRequestDetails/TransferRequestValidation",
        param
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);



const TransferRequestDetails = createSlice({
  name: "TransferRequestDetails",
  initialState: {
    TransferRequestDetails: {},
    loadingTransferRequestDetails: false,
    errorTransferRequestDetails: null,

    AddTransferRequestDetails: {},
    loadingAddTransferRequestDetails: false,
    errorAddTransferRequestDetails: null,

    UpdateTransferRequestDetails: {},
    loadingUpdateTransferRequestDetails: false,
    errorUpdateTransferRequestDetails: null,

    DeleteTransferRequestDetails: {},
    loadingDeleteTransferRequestDetails: false,
    errorDeleteTransferRequestDetails: null,


    TransferRequestValidation: {},
    loadingTransferRequestValidation: false,
    errorTransferRequestValidation: null,
  },
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetTransferRequestDetailsId.pending, (state, action) => {
        state.loadingTransferRequestDetails = true;
        state.TransferRequestDetails = action.payload;
        state.errorTransferRequestDetails = null;
      })
      .addCase(GetTransferRequestDetailsId.fulfilled, (state, action) => {
        state.loadingTransferRequestDetails = false;
        state.TransferRequestDetails = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetTransferRequestDetailsId.rejected, (state, action) => {
        state.loadingTransferRequestDetails = false;
        state.errorTransferRequestDetails = action.payload;
      })

      .addCase(DeleteTransferRequestDetails.pending, (state, action) => {
        state.loadingDeleteTransferRequestDetails = true;
        state.DeleteTransferRequestDetails = action.payload;
        state.errorDeleteTransferRequestDetails = null;
      })
      .addCase(DeleteTransferRequestDetails.fulfilled, (state, action) => {
        state.loadingDeleteTransferRequestDetails = false;
        state.DeleteTransferRequestDetails = action.payload; // Assuming payload has the desired data
      })
      .addCase(DeleteTransferRequestDetails.rejected, (state, action) => {
        state.loadingDeleteTransferRequestDetails = false;
        state.errorDeleteTransferRequestDetails = action.payload;
      })

      .addCase(UpdateTransferRequestDetails.pending, (state, action) => {
        state.loadingUpdateTransferRequestDetails = true;
        state.UpdateTransferRequestDetails = action.payload;
        state.errorUpdateTransferRequestDetails = null;
      })
      .addCase(UpdateTransferRequestDetails.fulfilled, (state, action) => {
        state.loadingUpdateTransferRequestDetails = false;
        state.UpdateTransferRequestDetails = action.payload; // Assuming payload has the desired data
      })
      .addCase(UpdateTransferRequestDetails.rejected, (state, action) => {
        state.loadingUpdateTransferRequestDetails = false;
        state.errorUpdateTransferRequestDetails = action.payload;
      })

      .addCase(AddTransferRequestDetails.pending, (state, action) => {
        state.loadingAddTransferRequestDetails = true;
        state.AddTransferRequestDetails = action.payload;
        state.errorAddTransferRequestDetails = null;
      })
      .addCase(AddTransferRequestDetails.fulfilled, (state, action) => {
        state.loadingAddTransferRequestDetails = false;
        state.AddTransferRequestDetails = action.payload; // Assuming payload has the desired data
      })
      .addCase(AddTransferRequestDetails.rejected, (state, action) => {
        state.loadingAddTransferRequestDetails = false;
        state.errorAddTransferRequestDetails = action.payload;
      })


      .addCase(TransferRequestValidation.pending, (state, action) => {
        state.loadingTransferRequestValidation = true;
        state.TransferRequestValidation = action.payload;
        state.errorTransferRequestValidation = null;
      })
      .addCase(TransferRequestValidation.fulfilled, (state, action) => {
        state.loadingTransferRequestValidation = false;
        state.TransferRequestValidation = action.payload; // Assuming payload has the desired data
      })
      .addCase(TransferRequestValidation.rejected, (state, action) => {
        state.loadingTransferRequestValidation = false;
        state.errorTransferRequestValidation = action.payload;
      });
  },
});

export default TransferRequestDetails.reducer;
